import React, { PropsWithChildren, useCallback } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styled from 'styled-components';

export interface AnchorProps extends PropsWithChildren {
  path: string | undefined;
  alwaysOpenInNewTab?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

const StyledLink = styled(Link)`
  &,
  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    color: inherit;
  }
`;

const Anchor: React.FC<AnchorProps> = ({ path, alwaysOpenInNewTab, onClick, children }) => {
  const navigate = useNavigate();

  const open = useCallback(
    (e: React.MouseEvent) => {
      if (onClick) {
        onClick(e);
      }

      if (path) {
        navigate(path);
      }

      e.preventDefault();
      e.stopPropagation();
      return false;
    },
    [onClick, path],
  );

  if (!path && !onClick) {
    return <>{children}</>;
  }
  return (
    <StyledLink
      to={path || '#'}
      onClick={open}
      target={alwaysOpenInNewTab ? '_blank' : undefined}
      rel={alwaysOpenInNewTab ? 'noopener noreferrer' : undefined}>
      {children}
    </StyledLink>
  );
};

export default React.memo(Anchor);
